import { Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const BERLIN: Series = {
  id: 'berlin',
  name: 'Berlin',
  location: LOCATIONS.BERLIN,
  sortType: 'date_asc',
  isZoneHighlight: true,
};

export default BERLIN;
